import CustomerAddress from "../models/CustomerAddress";
import {
  createCustomerAddress,
  customerAddressOperationPaths,
  setCustomerAddress,
  updateCustomerAddress,
} from "../store/customersSlice";
import * as CustomersAddressApi from "../api/CustomersAddress";
import { setError, setSuccess, startLoading } from "../store/appSlice";
import { fork, put, takeEvery } from "redux-saga/effects";
import { callApi } from "./helpers/api";
import { push } from "connected-react-router";

function* updateCustomerAddressSaga({
  payload,
}: {
  payload: { id: string; data: CustomerAddress };
  type: string;
}) {
  const { id, data } = payload;

  const { update: operationPath } = customerAddressOperationPaths(id);
  yield put(startLoading(operationPath));

  try {
    const customer = yield callApi(
      CustomersAddressApi.patchCustomerAddress,
      id,
      data
    );
    yield put(setCustomerAddress({ id, address: customer.address }));
    yield put(setSuccess(operationPath));
    yield put(push(`/configuration/customers/${id}`));
  } catch (error) {
    yield put(
      setError({
        path: operationPath,
        error,
      })
    );
  }
}

function* createCustomerAddressSaga({
  payload,
}: {
  payload: { id: string; data: CustomerAddress };
  type: string;
}) {
  const { id, data } = payload;

  const { create: operationPath } = customerAddressOperationPaths(id);
  yield put(startLoading(operationPath));

  try {
    const customer = yield callApi(
      CustomersAddressApi.postCustomerAddress,
      id,
      data
    );

    yield put(setCustomerAddress({ id, address: customer.address }));
    yield put(setSuccess(operationPath));
    yield put(push(`/configuration/customers/${id}`));
  } catch (error) {
    yield put(
      setError({
        path: operationPath,
        error: error,
      })
    );
  }
}

function* watchCreateCustomerAddress() {
  yield takeEvery(createCustomerAddress.type, createCustomerAddressSaga);
}
function* watchUpdateCustomerAddress() {
  yield takeEvery(updateCustomerAddress.type, updateCustomerAddressSaga);
}

export function* CustomersAddressSaga() {
  yield fork(watchCreateCustomerAddress);
  yield fork(watchUpdateCustomerAddress);
}
